<template>
	<div id="distribution" class="page" v-if="loaded">
		<div class='income'>
			<div class='top'>
				<div class='total-income'>总收益</div>
				<div class='money'>{{info.all_money}}</div>
			</div>
			<div class='middle'>
				<div class='left' v-if="userInfo.driver_level.distribution">
				  <div>考题收益</div>
				  <div class='money'>{{info.today_money}}</div>
				</div>
				<div class='center' v-if="userInfo.driver_level.distribution">
				  <div>模拟灯光收益</div>
				  <div class='money'>{{info.dg_money}}</div>
				</div>
				<div class='right' style="border-left:1px solid #FFFFFF;">
				  <div>打赏收益</div>
				  <div class='money'>{{info.yestoday_money}}</div>
				</div>
			</div>
			<div class='withdraw-button' bindtap="event_drawmoney">
				<router-link to="/drawmoney">
					<button class="withdraw">提 现</button>
				</router-link>
			</div>
		</div>
		<div class='distributio-nav'>
		  <div class='navlist' bindtap="event_commission">
		  	<router-link to="/commission">
			  <div class='iconfontt icon-mingxi'></div>
			  <span>佣金明细</span>
			</router-link>
		  </div>
		  <div class='navlist' bindtap="event_order" v-if="userInfo.driver_level.distribution">
		  	<router-link to="/order">
			  <div class='iconfontt icon-dingdan'></div>
			  <span>分销订单</span>
			</router-link>
		  </div>
		  <div class='navlist' bindtap="event_withdraw">
		  	<router-link to="/withdraw">
			  <div class='iconfontt icon-tixian-'></div>
			  <span>提现明细</span>
			</router-link>
		  </div>
		  <div class='navlist' bindtap="event_team" v-if="userInfo.driver_level.distribution">
		  	<router-link to="/team">
			  <div class='iconfontt icon-tuandui1' style="font-size:6vw;"></div>
			  <p class='myteam'>我的团队
				<span class='num'>({{info.team_count}})</span>
			  </p>
			</router-link>
		  </div>
		  <div class='navlist' bindtap="event_businessqcode" v-if="info.business_power && 0">
		  	<router-link :to="{path:'qcode2',query:{user_id:userInfo.id}}">
			  <div class='iconfontt icon-erweima'></div>
			  <span>{{info.child_driver_level}}代理码</span>
			</router-link>
		  </div>
		  <div class='navlist' bindtap="event_sellqcode" v-if="userInfo.driver_level.distribution && 0">
			<router-link :to="{path:'qcode1',query:{user_id:userInfo.id}}">
			  <div class='iconfontt icon-erweima' style="color:#35e195"></div>
			  <span>学员二维码</span>
			</router-link>
		  </div>
		</div>
	</div>
</template>

<script>
import { Toast , Dialog} from 'we-vue'
export default {
	data () {
		return {
			loaded:false,
			info:{},
			userInfo:this.$store.state.userInfo
		}
	},
	created () {
		this.$https.post('/api/user/info.html',this.$qs.stringify({
			token:this.$store.state.token
		})).then((res) => {
			this.userInfo = res.data.data
		},(res) => {
			console.log(res)
		})
		this.$https.post("/api/distribution/index",this.$qs.stringify({
			token:this.$store.state.token
		})).then((res) => {
			this.info = res.data.data
			this.loaded = true
		})
	},
	methods: {
		
	},
	filters: {
    
	}
}
</script>

<style scoped>
	#distribution{
		background-color:#efefef;
		min-height:100vh;
	}
	.income{
  color: #fff;
  background: linear-gradient(to right, #11d5ff, #00a6f3);
}
.income .top{
  text-align: center;
}
.income .top .total-income{
  padding-top: 25px;
  font-size: 14px;
}
.income .top .money{
  font-size: 40px;
}
.income .middle{
  display: flex;
  padding: 15px 0;
  justify-content: space-between;
  background: #3cd0fc;
  margin-top: 10px;
}
.income .middle > div{
  flex: 1;
  text-align: center;
}
.income .middle > div.left{
  border-right: 1px solid #fff;
}
.income .middle .money{
  font-size: 25px;
}
.withdraw-button{
  text-align: center;
  padding: 20px 0;
}
.withdraw-button button{
  width: 140px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 20px;
  font-size: 16px;
  background: 0;
  color: #fff;
  border:1px solid #fff;
}
.distributio-nav{
  margin-top: 10px;
  background: #fff;
  display: flex;
  margin-bottom: 40px;
  flex-flow: row wrap;
}
.distributio-nav .navlist{
  width: 33%;
  text-align: center;
  padding: 4vw 0;
  border-bottom:1px solid #ededed;
  border-right: 1px solid #ededed;
}
.distributio-nav span{
  font-size: 14px;
  color: #7d7d7d;
  margin-top: 5vw;
  display: inline-block;
}
.distributio-nav .iconfont{
  font-size: 25px;
}
.icon-mingxi{
  color: #ffba52;
}
.icon-dingdan{
  color: #46cdff;
}
.icon-tixian-{
  color: #ff6969;
}
.icon-tuandui1{
  color: #68ef7e;
  font-size: 30px;
}
.icon-erweima{
  color: #ff83ba;
}
.distributio-nav .num{
color: #ff515e;
}
.distributio-nav .myteam{
font-size: 14px;
color: #7d7d7d;
}
</style>


// WEBPACK FOOTER //
// src/components/Distribution.vue